import classNames from 'classnames';
import type { FC } from 'react';

import styles from './duration-toggle.module.scss';

export type DurationToggleProps = {
  activeIndex: 0 | 1;
  firstOption: string;
  onToggle: (activeIndex: 0 | 1) => void;
  secondOption: string;
};

export const DurationToggle: FC<DurationToggleProps> = ({ activeIndex, firstOption, onToggle, secondOption }) => (
  <div className={classNames(styles.wrapper)}>
    <button
      type="button"
      className={classNames(styles['toggle-button'], activeIndex === 0 && styles['toggle-button-active'])}
      data-testid="button-toggle-0"
      onClick={() => {
        onToggle(1);
      }}
    >
      {secondOption}
    </button>
    <button
      type="button"
      className={classNames(styles['toggle-button'], activeIndex === 1 && styles['toggle-button-active'])}
      data-testid="button-toggle-1"
      onClick={() => {
        onToggle(0);
      }}
    >
      {firstOption}
    </button>
  </div>
);
